// extracted by mini-css-extract-plugin
module.exports = {"localityDirectory":"LocalityDirectoryByTypeTemplate_localityDirectory__3Wj0_","truncate":"LocalityDirectoryByTypeTemplate_truncate__Vh2Ns"};